const STORAGE_KEY = "podhive:pending-storage-file";

// A file uploaded on the landing page is handed to the app through the URL
// (`/dashboard?storageFileId=...`). That handoff breaks whenever the signup is
// interrupted — the account already exists, the password is rejected, the user
// logs in through another tab — and the upload is then orphaned with no way to
// reach it. Mirroring the id here lets the dashboard pick it up on the next
// visit. `storageFileId` is a capability token on the backend, so any signed-in
// user holding it may resume the extraction.
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

interface PendingUpload {
	storageFileId: string;
	savedAt: number;
}

export function savePendingUpload(storageFileId: string): void {
	try {
		const entry: PendingUpload = { storageFileId, savedAt: Date.now() };
		localStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
	} catch {
		// Private mode / storage full — the URL handoff still works.
	}
}

export function takePendingUpload(): string | null {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (!raw) return null;

		localStorage.removeItem(STORAGE_KEY);

		const entry = JSON.parse(raw) as Partial<PendingUpload>;
		if (!entry.storageFileId || typeof entry.savedAt !== "number") return null;
		if (Date.now() - entry.savedAt > MAX_AGE_MS) return null;

		return entry.storageFileId;
	} catch {
		return null;
	}
}

export function clearPendingUpload(): void {
	try {
		localStorage.removeItem(STORAGE_KEY);
	} catch {
		// Nothing to do.
	}
}
